var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['zg-button', {
    [`zg-button--size-${_vm.size}`]: _vm.size,
    'zg-button--with-icons': _vm.icons.left || _vm.icons.right,
    'zg-button--round': _vm.round,
    'zg-button--outline': _vm.outline,
    'zg-button--link': _vm.link && (_vm.icons.left || _vm.icons.right),
    'zg-button--ghost': _vm.ghost,
    'zg-button--disabled': _vm.disabled || _vm.loading,
    'zg-button--full-width': _vm.fullWidth,
    'zg-button--full-width-mobile': _vm.fullWidthMobile,
    'zg-button--not-allowed': _vm.notAllowed
  }],attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.loading)?_c('zg-loader',{attrs:{"size":_vm.size,"button":""}}):[(_vm.icons && _vm.icons.left)?_c('zg-icon',{attrs:{"icon":_vm.icons.left,"rotate":_vm.icons.leftRotation}}):_vm._e(),_vm._v(" "),_c('span',[_vm._t("default")],2),_vm._v(" "),(_vm.icons && _vm.icons.right)?_c('zg-icon',{attrs:{"icon":_vm.icons.right,"rotate":_vm.icons.rightRotation}}):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }